import { put, call, all, spawn, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";

import { homeServices } from "../services/home";
import * as types from "../constants/home";
import * as actions from "../actions/home";
import { useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51LLrycE26qcfcvFI37ItOpxKFpVnXgFWfeeyi2QjjMZEkYUfPrHCTYeL8bNWoaFIVaGqsaGbPOO4156cOWtM024V00LCQK12z3"
);

// getDashboard
function* getDashboardWorker(action) {
  try {
    const result = yield call(homeServices.getDashboardService, action);
    // console.log('getDashboard', result);
    yield put(actions.getDashboardSuccess(result));
  } catch (err) {
    console.log("getDashboard err", err);
    yield put(actions.getDashboardFailed(err));
  }
}

function* getDashboardWatcher() {
  yield takeEvery(types.GET_DASHBOARD_REQUEST, getDashboardWorker);
}

// getUsers
function* getUsersWorker(action) {
  try {
    const result = yield call(homeServices.getUsersService, action);
    // console.log('getUsers', result);
    yield put(actions.getUsersSuccess(result));
  } catch (err) {
    console.log("getUsers err", err);
    yield put(actions.getUsersFailed(err));
    toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getUsersWatcher() {
  yield takeEvery(types.GET_USERS_REQUEST, getUsersWorker);
}

// getCourseUsers
function* getCourseUsersWorker(action) {
  try {
    const result = yield call(homeServices.getCourseUsersService, action);
    // console.log('getCourseUsers', result);
    yield put(actions.getCourseUsersSuccess(result));
  } catch (err) {
    console.log("getCourseUsers err", err);
    yield put(actions.getCourseUsersFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getCourseUsersWatcher() {
  yield takeEvery(types.GET_COURSE_USERS_REQUEST, getCourseUsersWorker);
}

// getCourseMessages
function* getCourseMessagesWorker(action) {
  try {
    const result = yield call(homeServices.getCourseMessagesService, action);
    // console.log("getCourseMessages", result);
    yield put(actions.getCourseMessagesSuccess(result));
  } catch (err) {
    console.log("getCourseMessages err", err);
    yield put(actions.getCourseMessagesFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getCourseMessagesWatcher() {
  yield takeEvery(types.GET_COURSE_MESSAGES_REQUEST, getCourseMessagesWorker);
}

// getAdmins
function* getAdminsWorker(action) {
  try {
    const result = yield call(homeServices.getAdminsService, action);
    // console.log("getAdmins", result);
    yield put(actions.getAdminsSuccess(result));
  } catch (err) {
    console.log("getAdmins err", err);
    yield put(actions.getAdminsFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getAdminsWatcher() {
  yield takeEvery(types.GET_ADMINS_REQUEST, getAdminsWorker);
}

// getCourses
function* getCoursesWorker(action) {
  try {
    const result = yield call(homeServices.getCoursesService, action);
    // console.log("getCourses", result,action);
    yield put(actions.getCoursesSuccess(result, action));
  } catch (err) {
    console.log("getCourses err", err);
    yield put(actions.getCoursesFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getCoursesWatcher() {
  yield takeEvery(types.GET_COURSES_REQUEST, getCoursesWorker);
}

// getNewCourses
function* getNewCoursesWorker(action) {
  try {
    const result = yield call(homeServices.getNewCoursesService, action);
    // console.log("getNewCourses", result);
    yield put(actions.getNewCoursesSuccess(result));
  } catch (err) {
    console.log("getNewCourses err", err);
    yield put(actions.getNewCoursesFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getNewCoursesWatcher() {
  yield takeEvery(types.GET_NEW_COURSES_REQUEST, getNewCoursesWorker);
}

// getWaitingCourses
function* getWaitingCoursesWorker(action) {
  try {
    const result = yield call(homeServices.getWaitingCoursesService, action);
    // console.log("getWaitingCourses", result);
    yield put(actions.getWaitingCoursesSuccess(result));
  } catch (err) {
    console.log("getWaitingCourses err", err);
    yield put(actions.getWaitingCoursesFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getWaitingCoursesWatcher() {
  yield takeEvery(types.GET_WAITING_COURSES_REQUEST, getWaitingCoursesWorker);
}

// postFolder
function* postFolderWorker(action) {
  try {
    const result = yield call(homeServices.postFolderService, action);
    yield put(actions.getDashboardRequest());
    // yield put(actions.postCourseSuccess(result));
    // console.log("postFolder", result);
    toast.success("Folder created successfully");
  } catch (err) {
    // yield put(actions.postCourseFailed(err));
    console.log("postFolder err", err);
    toast.error("Something went wrong");
  }
}

function* postFolderWatcher() {
  yield takeEvery(types.POST_FOLDER_REQUEST, postFolderWorker);
}

// postCourse
function* postCourseWorker(action) {
  try {
    const result = yield call(homeServices.postCourseService, action);
    yield put(actions.getCoursesRequest());
    yield put(actions.getDashboardRequest());
    yield put(actions.postCourseSuccess(result));
    yield put(actions.getCoursesRequest(0, 100, true));

    console.log("postCourse", result, action);
    toast.success("Course successfully sent for approval");
  } catch (err) {
    console.log("postCourse err", err);
    toast.error(err?.response?.data?.error ?? "Something went wrong");
  }
}

function* postCourseWatcher() {
  yield takeEvery(types.POST_COURSE_REQUEST, postCourseWorker);
}

// patchCourse
function* patchCourseWorker(action) {
  try {
    const result = yield call(homeServices.patchCourseService, action);
    yield put(actions.getCoursesRequest());
    yield put(actions.getDashboardRequest());
    yield put(actions.patchCourseSuccess(result));
    yield put(actions.getCoursesRequest(0, 100, true));

    // console.log("patchCourse", result);
    toast.success("Course successfully edited");
  } catch (err) {
    yield put(actions.patchCourseFailed(err));
    console.log("patchCourse err", err);
    toast.error("Something went wrong");
  }
}

function* patchCourseWatcher() {
  yield takeEvery(types.PATCH_COURSE_REQUEST, patchCourseWorker);
}

// patchContentReorder
function* patchContentReorderWorker(action) {
  try {
    const result = yield call(homeServices.patchContentReorderService, action);
    yield put(actions.patchContentReorderSuccess(result));
    let title = action?.title;
    // console.log("patchContentReorder", result);
    toast.success(`${title} successfully re-arranged`);
  } catch (err) {
    yield put(actions.patchContentReorderFailed(err));
    console.log("patchContentReorder err", err);
    toast.error("Something went wrong");
  }
}

function* patchContentReorderWatcher() {
  yield takeEvery(
    types.PATCH_CONTENT_REORDER_REQUEST,
    patchContentReorderWorker
  );
}

// deleteCourse
function* deleteCourseWorker(action) {
  try {
    const result = yield call(homeServices.deleteCourseService, action);
    // console.log("deleteCourse", result, action);
    yield put(actions.getCoursesRequest());
    yield put(actions.getDashboardRequest());
    yield put(actions.getCoursesRequest(0, 100, true));

    // let cor_id = action?.data?.cor_id;
    // let type = action?.data?.type;
    yield put(actions.getCoursesRequest());
    toast.success(result?.message);
  } catch (err) {
    // yield put(actions.deleteCourseFailed(err));
    console.log("deleteCourse err", err);
    toast.error("Something went wrong");
  }
}

function* deleteCourseWatcher() {
  yield takeEvery(types.DELETE_COURSE_REQUEST, deleteCourseWorker);
}

// getCourseEnrollReq
function* getCourseEnrollReqWorker(action) {
  try {
    const result = yield call(homeServices.getCourseEnrollReqService, action);
    // console.log("getCourseEnrollReq", result);
    yield put(actions.getDashboardRequest());

    // yield put(actions.getCoursesRequest());
    yield put(actions.getCourseEnrollReqSuccess(result));
  } catch (err) {
    console.log("getCourseEnrollReq err", err);
    yield put(actions.getCourseEnrollReqFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getCourseEnrollReqWatcher() {
  yield takeEvery(
    types.GET_COURSE_ENROLL_REQ_REQUEST,
    getCourseEnrollReqWorker
  );
}

// postCourseEnroll
function* postCourseEnrollWorker(action) {
  try {
    const result = yield call(homeServices.postCourseEnrollService, action);
    let sessionId = result?.id;
    if (sessionId) {
      const stripe = yield stripePromise;
      console.log("postCourseEnroll", result, result?.id, stripe);
      const { error } = yield stripe.redirectToCheckout({ sessionId });

      if (error) {
        console.error(
          "Error during redirect to Stripe Checkout:",
          error.message
        );
        toast.error(`An error occurred: ${error.message}`);
      } else {
        console.log("Redirected to Stripe Checkout successfully");
      }
    } else {
      toast.success(
        result?.message ?? "Request successfully sent for approval"
      );
    }
  } catch (err) {
    console.log("postCourseEnroll err", err);
    toast.error("Something went wrong");
  }
}

function* postCourseEnrollWatcher() {
  yield takeEvery(types.POST_COURSE_ENROLL_REQUEST, postCourseEnrollWorker);
}

// postApproveReq
function* postApproveReqWorker(action) {
  try {
    const result = yield call(homeServices.postApproveReqService, action);
    yield put(
      actions.getCourseEnrollReqRequest({ course_id: action?.data?.course_id })
    );
    yield put(actions.getDashboardRequest());

    // console.log("postApproveReq", result, action);
    toast.success("Successfully approved!");
  } catch (err) {
    console.log("postApproveReq err", err);
    toast.error("Something went wrong");
  }
}

function* postApproveReqWatcher() {
  yield takeEvery(types.POST_APPROVE_REQ_REQUEST, postApproveReqWorker);
}

// postQuiz
function* postQuizWorker(action) {
  try {
    const result = yield call(homeServices.postQuizService, action);
    yield put(actions.getAllContentsRequest(action?.data?.course_id));

    yield put(actions.postQuizSuccess(result));
    // console.log("postQuiz", result, action);
    toast.success("Successfully submitted!");
  } catch (err) {
    yield put(actions.postQuizFailed(err));

    console.log("postQuiz err", err);
    toast.error("Something went wrong");
  }
}

function* postQuizWatcher() {
  yield takeEvery(types.POST_QUIZ_REQUEST, postQuizWorker);
}

// getQuizDetails
function* getQuizDetailsWorker(action) {
  try {
    const result = yield call(homeServices.getQuizDetailsService, action);

    yield put(actions.getQuizDetailsSuccess(result));
    // console.log("getQuizDetails", result, action);
    // toast.success("Successfully submitted!");
  } catch (err) {
    yield put(actions.getQuizDetailsFailed(err));

    console.log("getQuizDetails err", err);
    toast.error("Something went wrong");
  }
}

function* getQuizDetailsWatcher() {
  yield takeEvery(types.GET_QUIZ_DETAILS_REQUEST, getQuizDetailsWorker);
}

// postSubmitQuiz
function* postSubmitQuizWorker(action) {
  try {
    const result = yield call(homeServices.postSubmitQuizService, action);
    // console.log("postSubmitQuiz", result, action);
    yield put(actions.postSubmitQuizSuccess(result));

    yield put(actions.getContentRequest(action?.data?.course_id, "quiz"));

    toast.success("Successfully Quiz submitted!");
  } catch (err) {
    yield put(actions.postSubmitQuizFailed(err));
    console.log("postSubmitQuiz err", err);
    toast.error("Something went wrong");
  }
}

function* postSubmitQuizWatcher() {
  yield takeEvery(types.POST_SUBMIT_QUIZ_REQUEST, postSubmitQuizWorker);
}

// getNews
function* getNewsWorker(action) {
  try {
    const result = yield call(homeServices.getNewsService, action);
    // console.log("getNews", result);
    yield put(actions.getNewsSuccess(result));
  } catch (err) {
    console.log("getNews err", err);
    yield put(actions.getNewsFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getNewsWatcher() {
  yield takeEvery(types.GET_NEWS_REQUEST, getNewsWorker);
}

// getDownloadedNews
function* getDownloadedNewsWorker(action) {
  try {
    const result = yield call(homeServices.getDownloadedNewsService, action);
    // console.log("getDownloadedNews", result);
    yield put(actions.getDownloadedNewsSuccess(result));
  } catch (err) {
    console.log("getDownloadedNews err", err);
    yield put(actions.getDownloadedNewsFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getDownloadedNewsWatcher() {
  yield takeEvery(types.GET_DOWNLOADED_NEWS_REQUEST, getDownloadedNewsWorker);
}

// postNews
function* postNewsWorker(action) {
  try {
    const result = yield call(homeServices.postNewsService, action);
    // console.log("postNews", result);
    yield put(actions.getNewsRequest());
    yield put(actions.getDownloadedNewsRequest());
    toast.success(result?.message);
  } catch (err) {
    yield put(actions.postNewsFailed(err));
    console.log("postNews err", err);
    toast.error("Something went wrong");
  }
}

function* postNewsWatcher() {
  yield takeEvery(types.POST_NEWS_REQUEST, postNewsWorker);
}

// getContent
function* getContentWorker(action) {
  try {
    const result = yield call(homeServices.getContentService, action);
    // console.log("getContent RESULT", result);
    yield put(actions.getContentSuccess(result));
  } catch (err) {
    console.log("getContent err", err);
    yield put(actions.getContentFailed(err));
    // toast.error(err?.response?.data?.messages[0]?.message);
  }
}

function* getContentWatcher() {
  yield takeEvery(types.GET_CONTENT_REQUEST, getContentWorker);
}

// postContent
function* postContentWorker(action) {
  try {
    const result = yield call(homeServices.postContentService, action);
    let { course, content_type } = action?.data;
    // console.log("postContent", result, action);
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    toast.success(`${capitalizeFirstLetter(content_type === 'text' ? 'Notes' : content_type)} uploaded successfully`);
    yield put(actions.postContentSuccess(result));
    yield put(actions.getDashboardRequest());
    yield put(actions.getAllContentsRequest(course));

    // yield put(actions.getContentRequest(course, con_type));
  } catch (err) {
    console.log("postContent err", err);
    yield put(actions.postContentFailed(err));
    toast.error(err?.message);
  }
}

function* postContentWatcher() {
  yield takeEvery(types.POST_CONTENT_REQUEST, postContentWorker);
}

// deleteContent
function* deleteContentWorker(action) {
  try {
    const result = yield call(homeServices.deleteContentService, action);
    // console.log("deleteContent", result, action);
    let cor_id = action?.data?.cor_id;
    let type = action?.data?.type;
    console.log(type, type);
    if (type === "quiz") {
      yield put(actions.getContentRequest(cor_id, type));
    } else {
      yield put(actions.getAllContentsRequest(cor_id));
    }
    toast.success(result?.message);
  } catch (err) {
    yield put(actions.deleteContentFailed(err));
    console.log("deleteContent err", err);
    toast.error("Something went wrong");
  }
}

function* deleteContentWatcher() {
  yield takeEvery(types.DELETE_CONTENT_REQUEST, deleteContentWorker);
}

// deleteFolder
function* deleteFolderWorker(action) {
  try {
    const result = yield call(homeServices.deleteFolderService, action);
    // console.log("deleteFolder", result, action);
    yield put(actions.getDashboardRequest());
    toast.success(result?.message);
  } catch (err) {
    yield put(actions.deleteFolderFailed(err));
    console.log("deleteFolder err", err);
    toast.error(`Unsuccessful! ${err?.response?.data?.message}`);
  }
}

function* deleteFolderWatcher() {
  yield takeEvery(types.DELETE_FOLDER_REQUEST, deleteFolderWorker);
}

// getAllContents
function* getAllContentsWorker(action) {
  try {
    const result = yield call(homeServices.getAllContentsService, action);
    // console.log("getAllContents", result);
    yield put(actions.getAllContentsSuccess(result));
    // toast.success(result?.message ?? '');
  } catch (err) {
    yield put(actions.getAllContentsFailed(err));
    console.log("getAllContents err", err);
    toast.error("Something went wrong");
  }
}

function* getAllContentsWatcher() {
  yield takeEvery(types.GET_ALL_CONTENTS_REQUEST, getAllContentsWorker);
}

// getSlug
function* getSlugWorker(action) {
  try {
    const result = yield call(homeServices.getSlugService, action);
    // console.log("getSlug", result);
    yield put(actions.getSlugSuccess(result));
    // toast.success(result?.message ?? '');
  } catch (err) {
    yield put(actions.getSlugFailed(err));
    console.log("getSlug err", err);
    toast.error("Something went wrong");
  }
}

function* getSlugWatcher() {
  yield takeEvery(types.GET_SLUG_REQUEST, getSlugWorker);
}

// getMail
function* getMailWorker(action) {
  try {
    const result = yield call(homeServices.getMailService, action);
    // console.log("getMail", action, result);
    yield put(actions.getMailSuccess(result));
    // toast.success(result?.message ?? '');
  } catch (err) {
    yield put(actions.getMailFailed(err));
    console.log("getMail err", err);
    toast.error("Something went wrong");
  }
}

function* getMailWatcher() {
  yield takeEvery(types.GET_MAIL_REQUEST, getMailWorker);
}

// sendMail
function* sendMailWorker(action) {
  try {
    const result = yield call(homeServices.sendMailService, action);
    // console.log("sendMail", result);
    if (result?.errors.length) {
      toast.error(result?.errors[0]);
    } else {
      toast.success(result?.sent[0] ?? "Sent an I-Mail");
    }
    yield put(actions.getMailRequest());
  } catch (err) {
    yield put(actions.sendMailFailed(err));
    console.log("sendMail err", err);
    toast.error(err?.response?.data?.error ?? "Something went wrong");
  }
}

function* sendMailWatcher() {
  yield takeEvery(types.SEND_MAIL_REQUEST, sendMailWorker);
}

// readMail
function* readMailWorker(action) {
  try {
    const result = yield call(homeServices.readMailService, action);
    // console.log("readMail", result);
    // yield put(actions.getMailRequest());
  } catch (err) {
    yield put(actions.readMailFailed(err));
    console.log("readMail err", err);
    toast.error("Something went wrong");
  }
}

function* readMailWatcher() {
  yield takeEvery(types.READ_MAIL_REQUEST, readMailWorker);
}

// getS3Url
function* getS3UrlWorker(action) {
  try {
    const result = yield call(homeServices.getS3UrlService, action);
    console.log("getS3Url", result);
    // yield put(actions.getMailRequest());
  } catch (err) {
    yield put(actions.getS3UrlFailed(err));
    console.log("getS3Url err", err);
    toast.error("Something went wrong");
  }
}

function* getS3UrlWatcher() {
  yield takeEvery(types.GET_S3_URL_REQUEST, getS3UrlWorker);
}

// deleteMail
function* deleteMailWorker(action) {
  try {
    const result = yield call(homeServices.deleteMailService, action);
    let { mail_type } = action;
    let type;
    let bool;
    if (mail_type === 1) {
      type = "";
      bool = false;
    } else if (mail_type === 2) {
      type = "unread";
      bool = false;
    } else if (mail_type === 3) {
      type = "unread";
      bool = true;
    } else if (mail_type === 4) {
      type = "sent";
      bool = true;
    }
    yield put(actions.deleteMailSuccess(result));
    yield put(actions.getMailRequest(type, bool));
    // toast.success(result?.message ?? '');
  } catch (err) {
    yield put(actions.deleteMailFailed(err));
    console.log("deleteMail err", err);
    toast.error("Something went wrong");
  }
}

function* deleteMailWatcher() {
  yield takeEvery(types.DELETE_MAIL_REQUEST, deleteMailWorker);
}

// stripeOnboard
function* stripeOnboardWorker(action) {
  try {
    const result = yield call(homeServices.stripeOnboardService, action);
    // console.log("stripeOnboard", result);
    window.location.href = result?.account_link?.url;


    // yield put(actions.getMailRequest());
  } catch (err) {
    yield put(actions.stripeOnboardFailed(err));
    console.log("stripeOnboard err", err);
    toast.error("Something went wrong");
  }
}

function* stripeOnboardWatcher() {
  yield takeEvery(types.STRIPE_ONBOARD_REQUEST, stripeOnboardWorker);
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* homeRootSaga() {
  const sagas = [
    getDashboardWatcher,
    getUsersWatcher,
    postFolderWatcher,
    getCoursesWatcher,
    getNewCoursesWatcher,
    getWaitingCoursesWatcher,
    postCourseWatcher,
    getNewsWatcher,
    getDownloadedNewsWatcher,
    postNewsWatcher,
    getContentWatcher,
    postContentWatcher,
    deleteContentWatcher,
    postCourseEnrollWatcher,
    getCourseEnrollReqWatcher,
    postApproveReqWatcher,
    getMailWatcher,
    sendMailWatcher,
    readMailWatcher,
    postQuizWatcher,
    getAdminsWatcher,
    patchCourseWatcher,
    deleteCourseWatcher,
    postSubmitQuizWatcher,
    deleteFolderWatcher,
    getCourseUsersWatcher,
    stripeOnboardWatcher,
    getAllContentsWatcher,
    getSlugWatcher,
    deleteMailWatcher,
    patchContentReorderWatcher,
    getCourseMessagesWatcher,
    getQuizDetailsWatcher,
    getS3UrlWatcher,
  ];

  yield all(
    sagas.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log("error", e);
          }
        }
      })
    )
  );
}
